import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { User } from 'src/app/shared/models';

@Component({
  selector: 'app-common',
  templateUrl: './common.component.html',
  styleUrls: ['./common.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CommonComponent extends DestructorComponent {
  commonChildren: Route[] = [];
  user:User | null = null;
  constructor(private router: Router, private _globalStateService:GlobalStateService) {
    super();
   }

  ngOnInit(): void {
    const commonRoute = this.router.config.find(r => r.path === 'common');

    let routeCommonChildren = commonRoute?.children ?? []
    this.subscriptions.push(
      this._globalStateService.user.subscribe(user => {
        this.user = user;

        if(this.user?.role_complete.is_admin){
            this.commonChildren = commonRoute?.children ?? [];
        }
        else{
            this.commonChildren = routeCommonChildren.filter((child:any) => {
              return this.user?.role_complete.permissions[child.path]?.view;
            });
        }
      })
    );

    // Get only first-level children
    

    console.log("Childrend--->", this.commonChildren)
  }
}
